// First-party
import { createPage } from '@/common/util/templateHelpers';

// Component lib
import { Meta } from '@/common/components/head';

// Local
import { Block, Content, RouterLink, Title } from '@/common/components';
import AboutPageLayout from '@/layouts/AboutPageLayout';

export default createPage('ContentRatingsPage', {}, function ContentRatingsPage ({ className }) {

  const description = 'What Do Our Ratings Mean? We want everyone to have a fun and enjoyable experience playing games on AddictingGames. We especially want to educate our users and parents about which games are appropriate to play given each player&#039;s maturity level.';
  const twitterDescription = 'What Do Our Ratings Mean? We want everyone to have a fun and enjoyable experience playing games on AddictingGames. We especially want to educate our users and parents about which games are';
  const metaProps = {
    itemDescription: description,
    description: description,
    openGraph: {
      url: process.env.APP_CONFIG.URL + '/about/content-ratings',
      description: description,
      updated_time: '2018-12-13T07:48:23-08:00',
      'article:published_time': '2018-12-13T07:23:39-08:00',
      'article:modified_time': '2018-12-13T07:48:23-08:00',
    },
    twitter: {
      description: twitterDescription
    }
  };
  return (
    <AboutPageLayout className={className}>
      <Meta 
        titleTag='What Do Our Ratings Mean? | Addicting Games'
        title='What Do Our Ratings Mean?' 
        {...metaProps}
      />

      <Block>
        <Title>What Do Our Ratings Mean?</Title>

        <Content>
          <p>We want everyone to have a fun and enjoyable experience playing games on AddictingGames. We especially want to educate our users and parents about which games are appropriate to play given each player's maturity level.</p>
          <p>To educate our users and their adult supervisors on games they may not find appropriate, AddictingGames provides a Game Rating System to assist users in identifying appropriate games given their maturity level. Below are the details of our rating system. Our goal is to help everyone find the games they like to play, so use our rating system as a guide to help you find the best games on the site for you!</p>
          <p><strong>All Ages</strong><br />
          Games rated "All Ages" contain content and themes that are suitable for all ages.</p>
          <p><strong>Teen+</strong><br />
          Games rated "Teen +" contain suggestive themes that are suitable for ages 13 and older.</p>
          <p><strong>Teen Caution</strong> <span></span><br />
          Games rated "Teen Caution" <span></span> contain content and stronger suggestive themes that may or may not be suitable for ages 13 and older.</p>
          <p>Adults supervising young people who visit AddictingGames should discuss what games are appropriate for their young person to play. If you are supervising a young person on this site, look for the rating in the Game Information section on each game page. You can also <RouterLink href="/about/parents">click here for more information about moderating your young person's experience</RouterLink>.</p>
        </Content>
      </Block>
    </AboutPageLayout>
  );
});